<template>
  <div class="content-pages">
    <ul class="pagination-list">
      <li>
        <a
          :class="currentPage <= startPage || loading ? 'disabled' : 'active'"
          :disabled="currentPage <= startPage || loading"
          @click="toPreviousPage"
          alt="anterior"
        >
          <i class="fas fa-angle-left"></i>
        </a>
      </li>
      <li v-show="hiddenGoToFirst">
        <span class="pagination-ellipsis">&hellip;</span>
      </li>
      <li v-for="(current, index) in pagesArray" :key="index">
        <a
          class="active"
          :disabled="loading"
          @click="goToPage(current)"
          :class="[{ 'is-current': current === currentPage }, { 'disabled': loading }]"
        >{{ current }}</a>
      </li>
      <li v-show="hiddenToLastPage">
        <span class="pagination-ellipsis">&hellip;</span>
      </li>
      <li>
        <a
          :class="currentPage === endPage || loading ? 'disabled' : 'active'"
          :disabled="currentPage >= endPage || loading"
          @click="toNextPage"
          alt="siguiente"
        >
          <i class="fas fa-angle-right"></i>
        </a>
      </li>
    </ul>

  </div>
</template>

<script>
import range from 'lodash/range'

export default {
  name: 'BasePagination',
  props: {
    page: {
      type: Number,
      required: true,
      default: 1
    },
    pages: {
      type: Number,
      required: true,
      default: 0
    },
    action: {
      type: Function,
      required: true
    },
    displayPages: {
      type: Number,
      default: 5
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emptyArray: 0,
      currentPage: 1,
      startPage: 1,
      secondPage: 2
    }
  },
  computed: {
    endPage () { return this.pages },
    secondLastPage () { return this.pages - 1 },
    normalizePagesForArray () { return this.pages + 1 },
    normalizeDisplayPages () { return this.displayPages + 1 },
    hiddenGoToFirst () { return this.currentPage > 5 },
    hiddenToLastPage () { return this.currentPage < (this.endPage - 5) },
    pagesArray () {
      const {
        page,
        pages,
        displayPages,
        normalizeDisplayPages,
        startPage,
        normalizePagesForArray
      } = this

      let startRange = this.startPage
      let endRange = this.normalizePagesForArray

      if (pages === startPage) return [1]
      if (pages === startRange) return [startRange]
      if (pages <= displayPages) return range(startRange, endRange)

      if (page >= (normalizePagesForArray - this.displayPages)) {
        startRange = normalizePagesForArray - this.displayPages
        endRange = this.normalizePagesForArray
      } else if (page >= displayPages) {
        startRange = this.isOdd(displayPages) ? (page + 1) - (normalizeDisplayPages / 2) : page - (displayPages / 2)
        endRange = this.isOdd(displayPages) ? page + (normalizeDisplayPages / 2) : page + (displayPages / 2)
      } else {
        endRange = normalizeDisplayPages
      }

      return range(startRange, endRange)
    }
  },
  watch: {
    page (newValue) {
      this.goToPage(newValue)
    }
  },
  methods: {
    isOdd (number) { return (number % 2) === 1 },
    toFirstPage () {
      this.goToPage(this.startPage)
    },
    toPreviousPage () {
      this.goToPage(this.currentPage - 1)
    },
    toNextPage () {
      this.goToPage(this.currentPage + 1)
    },
    toLastPage () {
      this.goToPage(this.endPage)
    },
    goToPage (page) {
      if (page !== this.currentPage && !this.loading && page >= this.startPage && page <= this.endPage) {
        this.action(page)
        this.currentPage = page
      }
    },
    pageToIndexArrayValue: (value) => value - 1
  },
  mounted () {
    this.goToPage(this.page)
  }
}
</script>

<style lang="scss" scoped>
.content-pages {
  width: 100%;
  display: grid;
  justify-content: center;
  .pagination-list {
    margin: auto;

    li {
      margin: 10px;
      .active {
        color: #7c7d7e;
        font-weight: 500;
      }
      .disabled {
        cursor: not-allowed;
        color: #e3e3e3;
      }
      .is-current {
        color: #4c70ff;
        font-weight: 500;
      }
      &:hover {
        .active {
          color: #4c70ff;
        }
      }
    }
  }
}
</style>
